import React, { useState } from 'react'
import '../App.css'
import LoginRequest from './LoginRequest'
import AddBlacklist from './AddBlacklist'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'

const Blacklist = (props) => {
  props.stopListRefresh()

  //const [isloggedIn, setIsLoggedIn] = useState(true)
  const [isOpen, setIsOpen] = useState(false)
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  /*  useEffect(() => {
    const fetchLogin = async () => {
      if (userToken === null) {
        console.log('kirjaudu sisään')
        setIsLoggedIn(false)
      }
    }
    fetchLogin()
    // DON'T DELETE THE COMMENT BELOW!!
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }

  const removeData = async (blacklistId) => {
    try {
      await axios.delete(`${SERVER_URI}/remove_from_blacklist/${blacklistId}`, {
        headers: { Authorization: `Token ${userToken}` },
      })
    } catch (e) {
      console.log('Error in deleting the contact', e)
    }
    props.dispatch({
      type: 'DELETE_FROM_BLACKLIST',
      data: { blacklistId: blacklistId },
    })
  }

  return (
    <div className='configurations'>
      {isOpen && (
        <AddBlacklist dispatch={props.dispatch} handleClose={togglePopUp} />
      )}
      <h3>Estetyt numerot</h3>
      <span>
        <div className='discountRates'>
          <button id='lightBlue_button' onClick={togglePopUp}>
            Lisää estolistalle
          </button>
          {props.blacklist === undefined ? (
            <LoginRequest />
          ) : props.blacklist.length === 0 ? (
            <h4>Ei numeroita</h4>
          ) : (
            <table id='contactTable'>
              <thead>
                <tr>
                  <th>Ilmoittajan sähköposti</th>
                  <th>Estetty numero</th>
                  <th>Syy</th>
                </tr>
              </thead>
              <tbody>
                {props.blacklist.map((blacklist) => (
                  <tr key={blacklist.id} id={blacklist.id}>
                    <td>{blacklist.adminEmail}</td>
                    <td>{blacklist.phoneNumber}</td>
                    <td>{blacklist.reason}</td>

                    <td className='operation'>
                      <button onClick={() => removeData(blacklist.id)}>
                        Poista
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </span>
    </div>
  )
}

export default Blacklist
